import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GraphQLError } from "graphql";
import {
  AssignDiscountGQL,
  EditAssignDiscountGQL,
  GetAssignedDiscountByIdGQL,
  GetAssignDiscountFormSourceGQL
} from "../../../../generated/graphql";
import { SnackBarService } from "../../service/snack.bar.service";
import * as moment from "moment";

export enum FormRequestType {
  EDIT = "edit",
  ADD = "create"
}

export class IntegrationTypeEnum {
  NET = "DOTNET"
  PPLUS = "PPLUS"
}


export interface DialogData {
  type: string;
  projectId: string;
  discountId: string;
  effectiveDate: Date;
  expiredDate: Date;
}

@Component({
  selector: "assign-discount-dialog",
  templateUrl: "assign-discount-dialog.html",
})
export class AssignDiscountDialog {
  result: DialogData = {
    type: "",
    projectId: "",
    discountId: null,
    effectiveDate: null,
    expiredDate: null,
  };
  discountOptions: any;
  projectId: string;
  formType: string;
  formGrp: FormGroup;
  formTypeRequest = FormRequestType;
  projectIntegratedType: string | undefined = undefined;
  integrationType = new IntegrationTypeEnum();

  constructor(
    private GetAssignedDiscountByIdGQL: GetAssignedDiscountByIdGQL,
    private AssignDiscountGQL: AssignDiscountGQL,
    private getAssignDiscountFormSourceGQL: GetAssignDiscountFormSourceGQL,
    private EditAssignDiscountGQL: EditAssignDiscountGQL,
    private snackBarService: SnackBarService,
    public dialogRef: MatDialogRef<AssignDiscountDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.formType = data.type
    this.initFormGroup(data);
    if (data.type == this.formTypeRequest.ADD) this.getDiscountOptions();
    this.patchForm(data);
  }

  private initFormGroup(data) {
    if (data.type == this.formTypeRequest.EDIT) {
      this.formGrp = new FormGroup({
        discountId: new FormControl({ value: "", disabled: true }),
        effectiveDate: new FormControl("", [Validators.required]),
        expiredDate: new FormControl("", [Validators.required]),
      });
    } else {
      this.formGrp = new FormGroup({
        discountId: new FormControl("", [Validators.required]),
        effectiveDate: new FormControl("", [Validators.required]),
        expiredDate: new FormControl("", [Validators.required]),
      });
    }
  }

  private getDiscountOptions() {
    this.getAssignDiscountFormSourceGQL.fetch({ projectId: this.data.projectId }).subscribe(
      (result) => {
        if (result?.errors) {
          this.snackBarService.showQueryError(result.errors);
        }
        this.discountOptions = result.data.getAssignDiscountFormSource?.discount;
        this.projectIntegratedType = result.data.getAssignDiscountFormSource?.integrationType;
      }
    );
  }

  patchForm(data) {
    if (data.type == this.formTypeRequest.ADD) return;
    this.GetAssignedDiscountByIdGQL.fetch({
      discountId: data.projectDiscountId,
      projectId: data.projectId,
    }).subscribe(
      (result) => {

        if (result?.errors) return this.snackBarService.showQueryError(result.errors);

        let projectDiscount = result.data.getAssignedDiscountById;
        this.discountOptions = [result.data.getAssignedDiscountById.discount];

        this.formGrp.controls.discountId.setValue(
          projectDiscount.discountId
        );
        this.formGrp.controls.effectiveDate.setValue(
          projectDiscount.effectiveDate
        );
        this.formGrp.controls.expiredDate.setValue(
          projectDiscount.expired_date
        );
      }
    );
  }

  patchIntegrateSystemDate(index: number) {
    if (this.projectIntegratedType != this.integrationType.NET) return;
    let integrationDiscount = this.discountOptions[index].discountIntegration;
    this.formGrp.controls.effectiveDate.setValue(integrationDiscount.effectiveDate);
    this.formGrp.controls.expiredDate.setValue(integrationDiscount.expiredDate);
    this.formGrp.controls.effectiveDate.disable();
    this.formGrp.controls.expiredDate.disable();
  }


  onSubmit() {
    this.formGrp.markAllAsTouched();

    if (this.formGrp.controls.effectiveDate.value > this.formGrp.controls.expiredDate.value) {
      this.snackBarService.show(
        "Please Select Valid Dates."
      );
    }
    else if (this.formGrp.valid) {

      let expired_date = new Date(moment(this.formGrp.controls.expiredDate.value).format("YYYY-MMM-DD"));

      if (this.data.type == "create") {
        this.AssignDiscountGQL.mutate({
          input: {
            discountId: this.formGrp.controls.discountId.value,
            effectiveDate: this.formGrp.controls.effectiveDate.value,
            expired_date: expired_date,
            projectId: this.data.projectId,
          },
        }).subscribe((result) => {
          this.snackBarService.show("Assigned Successfully");
          this.dialogRef.close();
        }, (err: GraphQLError) => {
          this.snackBarService.show(err.message.split("Error:")[1]);
        });
      } else {
        this.EditAssignDiscountGQL.mutate({
          input: {
            discountId: this.formGrp.controls.discountId.value,
            effectiveDate: this.formGrp.controls.effectiveDate.value,
            expired_date: expired_date,
            projectId: this.data.projectId,
          },
        }).subscribe((result) => {
          this.snackBarService.show("Edited Successfully");
          this.dialogRef.close();
        }, (err: GraphQLError) => {
          this.snackBarService.show(err.message.split("Error:")[1]);
        });
      }
    } else {
      this.snackBarService.show(
        "Please complete or correct the required field(s)."
      );
    }
  }
}
